"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGuideInfoWindowDevelopment = void 0;
var React = require("react");
exports.DbGuideInfoWindowDevelopment = function (props) { return (React.createElement("div", null,
    React.createElement("div", { style: { maxWidth: '300px' } }, props.description))); };
